<template>
  <div>
    <div v-if="materialTypes.length > 1" class="sidebar-filter-material-type">
      <div class="material-type mb-4">
        <p class="label">{{$t('common.filterMaterialType')}}</p>
        <div class="available-types">
          <div v-for="(type, i) in materialTypes" :key="`material-type-${i}`"
               class="material-type pointer mb-1"
               :class="{'selected': type.id === selectedMaterialType}"
               @click="handleMaterialType(type)">
              <span v-html="type.name"></span>
              <span class="text-secondary pl-1">{{type.count}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    materialTypes: null,
  },
  data() {
    return {
      selectedMaterialType: null,
    };
  },
  methods: {
    handleMaterialType(type) {
      if (this.materialTypes.length > 1) {
        if (this.selectedMaterialType === type.id) {
          this.deselectMaterialType(type);
        } else {
          this.selectMaterialType(type);
        }
      }
    },
    selectMaterialType(type) {
      this.selectedMaterialType = type.id;
      this.$root.$emit('relatedMaterialTypeSelected', type);
    },
    deselectMaterialType(type) {
      this.selectedMaterialType = null;
      this.$root.$emit('relatedMaterialTypeDeselected', type);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/common.scss';
.sidebar-filter-material-type {
  font-size: 13px;
  .label {
    color: $secondary;
    text-transform: uppercase;
    font-size: 11px;
    margin-bottom: .5rem;
  }
  .available-types {
    .material-type {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: .8rem 1.4rem;
      text-transform: uppercase;
      border: 1px solid #d8d8d8;
      border-radius: 7px;
      &.selected {
        font-weight: bold;
        border-color: $secondary;
      }
    }
  }
}
.material-type {
  .available-types {
    .type {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: .4rem 0;
      img {
        max-width: 13px;
        transform: rotate(90deg);
        margin-right: 2rem;
      }
    }
  }
}
@include media-breakpoint-down(lg) {
  .sidebar-filter-material-type {
    font-size: 11px;
    .label {
      font-size: 9px;
    }
  }
}
</style>
